// extracted by mini-css-extract-plugin
export default {"mobile":"_1KAYv","root":"iuOaX","onImage":"g2h69"};